/* eslint-disable */

(function() {
  'use strict';

  function searchbox() {
    //should be 768 but for some reason this is accurate
    if (window.innerWidth < 991) {
      $('.logo-area .logo').insertBefore('.top-bar .navbar-toggle');
      $('.logo-area .search-area').insertBefore('.top-bar .navbar-toggle');
      $('.logo-area .basket-area').insertBefore('.top-bar .navbar-toggle');
    } else {
      $('.top-bar .logo').insertBefore('.helpline');
      $('.top-bar .search-area').insertAfter('.helpline');
      $('.top-bar .basket-area').appendTo('.logo-area');
    }
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  searchbox();

  if (getParameterByName('searchtext') !== null) {
    $('.search-area input[type=text]').attr('value', getParameterByName('searchtext'));
    if ($('.search-main').length > 0) {
      $('.search-main input[type=text]').attr('value', getParameterByName('searchtext'));
    }
  }

  $(window).resize(function() {
    searchbox();
  });
})();
